const SESSION_STORAGE_KEY = "arenatours-analytics-session";

export function getAuthToken() {
  return window.localStorage.getItem(SESSION_STORAGE_KEY);
}

export function setAuthToken(token: string) {
  window.localStorage.setItem(SESSION_STORAGE_KEY, token);
}

export function clearAuthToken() {
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
}
